import { Slide, ToastOptions } from 'react-toastify'
import { ToastLayoutProps } from '../ToastLayout'

export const PLAYER_ID = 'player'

export const COMMON_OPTIONS: ToastOptions = {
  icon: false,
  transition: Slide,
  position: 'bottom-right'
}

type ToastDispatcherParams = {
  title?: ToastLayoutProps['title']
  content: ToastLayoutProps['content']
  id?: string // Specify to update a toast if existing with same id, leave out to create a new instance
  config?: ToastOptions
}

export type ToastDispatcher = ({ title, content }: ToastDispatcherParams) => void
